// src/hooks/use-device-view.js
import { useTheme, useMediaQuery } from '@mui/material';

const useDeviceView = () => {
  const theme = useTheme();

  // Default MUI breakpoints:
  // xs: 0px, sm: 600px, md: 900px, lg: 1200px, xl: 1536px
  const isPhone = useMediaQuery(theme.breakpoints.down('sm')); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px–899px
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // ≥900px
  const isLandscape = useMediaQuery('(orientation: landscape)');

  const useCompactLayout = isPhone || (isTablet && !isLandscape); // compact layout for phone or tablet portrait

  return {
    isPhone,
    isTablet,
    isDesktop,
    isLandscape,
    useCompactLayout,
  };
};

export default useDeviceView;
